import {
  Input,
  MultiSearchForm,
  paymentTypeOptions,
  useDebouncedSearch,
  useEffect,
  useRef,
  useState,
} from "@";
import { searchValues } from "../utils/options";
import { getDetailedReportSearchData } from "../utils/api";

// MultiSearch component
const MultiSearch = ({ search, onSubmit, dataLength, updateSearch }) => {
  const hasFetchedData = useRef(false);
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);

  useDebouncedSearch(onSubmit, search.values, searchValues);

  const fetchData = async () => {
    try {
      const [categories, projects] = await getDetailedReportSearchData();
      setCategories(
        categories?.data?.map(({ id, name }) => ({ value: id, label: name })),
      );
      setProjects(
        projects?.data?.data?.map(({ id, title }) => ({
          value: id,
          label: title,
        })),
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (dataLength > 0 && !hasFetchedData.current) {
      fetchData();
      hasFetchedData.current = true;
    }
  }, [dataLength]);

  const handleInputChange = (field, value) => {
    updateSearch({ values: { ...search.values, [field]: value } });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-5"
      reset={() => updateSearch({ values: searchValues })}
    >
      <Input
        star
        label="كلمة البحث"
        value={search.values.searchKey}
        change={(e) => handleInputChange("searchKey", e.target.value)}
      />
      <Input
        star
        label="تصنيف التبرع"
        type="select-searchable"
        list={categories}
        value={categories?.filter(
          (c) => search.values.classificationId == c.value,
        )}
        change={(e) =>
          handleInputChange("classificationId", e ? e.value : null)
        }
      />
      <Input
        star
        type="select"
        label="طريقة الدفع"
        list={paymentTypeOptions}
        value={search.values.paymentType}
        change={(e) => handleInputChange("paymentType", e.target.value)}
      />
      <Input
        star
        label=" المشاريع"
        type="select-searchable"
        list={projects}
        value={projects?.filter((c) => search.values.project == c.value)}
        change={(e) => handleInputChange("project", e ? e.value : null)}
      />
      <Input
        star
        type="number-range"
        labelA="المبلغ من"
        labelB="المبلغ الي"
        valueA={search.values.fromAmount}
        valueB={search.values.toAmount}
        changeA={(e) => handleInputChange("fromAmount", e.target.value)}
        changeB={(e) => handleInputChange("toAmount", e.target.value)}
      />
      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="lg:col-span-2"
        valueA={search.values.fromDate}
        valueB={search.values.toDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
